import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Discover from "@/pages/Discover";
import Pipeline from "@/pages/Pipeline";
import LeadDetail from "@/pages/LeadDetail";
import Profile from "@/pages/Profile";
import Landing from "@/pages/Landing";
import AdminWaitlist from "@/pages/AdminWaitlist";
import AdminMessages from "@/pages/AdminMessages";
import AppGate from "@/pages/AppGate";

const TOASTER_OPTIONS = {
  style: {
    background: "#0a0a0a",
    color: "#ededed",
    border: "1px solid #222",
    borderRadius: 0,
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 12,
  },
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/app" element={<AppGate />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="discover" element={<Discover />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOASTER_OPTIONS}
      />
    </div>
  );
}

export default App;
